module.exports = __webpack_public_path__ + "static/media/wax.86d3c6e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clients/wax.svg
// module id = 102
// module chunks = 3